import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-suodingzhuangtai",
  "use": "icon-suodingzhuangtai-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-suodingzhuangtai\">\r\n<title>suodingzhuangtai</title>\r\n<path d=\"M15.644 4.303c2.773 0 4.953 2.176 4.953 4.776v3.534h-9.906v-3.534c0-2.6 2.18-4.776 4.953-4.776zM9.269 15.46c0.026 0 0.051-0.001 0.077-0.002h12.597c0.025 0.001 0.051 0.002 0.077 0.002s0.051-0.001 0.077-0.002h3.28v11.5h-19.469v-11.5h3.285c0.025 0.001 0.051 0.002 0.077 0.002zM7.847 9.079v3.534h-2.122c-1.537 0-2.662 1.289-2.662 2.726v11.736c0 1.437 1.125 2.726 2.662 2.726h19.834c1.537 0 2.662-1.289 2.662-2.726v-11.736c0-1.437-1.125-2.726-2.662-2.726h-2.117v-3.534c0-4.246-3.529-7.62-7.797-7.62s-7.798 3.374-7.798 7.62zM17.054 18.815v4.782c0 0.785-0.637 1.422-1.422 1.422s-1.422-0.637-1.422-1.422v-4.782c0-0.786 0.637-1.422 1.422-1.422s1.422 0.637 1.422 1.422z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/suodingzhuangtai.svg
// module id = yt3a
// module chunks = 14